var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['login-header']},[_c('a',{class:_vm.$style.logo,attrs:{"href":_vm.localeBaseUrl}},[_c('DealerPortalLogo',{staticClass:"mr-12 mt-2"})],1),_c('NavigationLanguageSwitch',{staticClass:"mr-6",class:_vm.$style['nav-button']})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }